const STORAGE_KEY = "tb.submittedTextFields";

/**
 * Text fields this browser has answered, so a returning participant counts as finished.
 * The share-link API never returns the visitor's own responses (same as votes, see guestVotes).
 * @returns Ids of submitted text fields
 */
export const readSubmittedTextFieldIds = (): string[] => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) {
            return [];
        }

        const parsed = JSON.parse(stored);
        return Array.isArray(parsed)
            ? parsed.filter(
                  (id: unknown): id is string =>
                      typeof id === "string" && id.length > 0
              )
            : [];
    } catch {
        return [];
    }
};

/**
 * Records a text field the server accepted a response for.
 * @param textFieldId - Id of the submitted text field
 */
export const rememberSubmittedTextField = (textFieldId: string): void => {
    const ids = readSubmittedTextFieldIds();
    if (ids.includes(textFieldId)) {
        return;
    }

    try {
        localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify([...ids, textFieldId])
        );
    } catch {
        // Persistence is best-effort; ignore failures.
    }
};
